// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3HdkK","option":"styles_option__2OcB2","active":"styles_active__1-UXm"};